import React, { useEffect } from 'react';
import { array, bool, func, number, object, shape, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { propTypes } from '../../util/types';
import {
  checkValidCode,
  hasCurrentUserErrors,
  openMissingInfomationModal,
  resendMobileCode,
  sendMobileCode,
  sendVerificationEmail,
} from '../../ducks/user.duck';
import { authenticationInProgress, logout } from '../../ducks/Auth.duck';
import {
  manageDisableScrolling,
  setupWaitingForUploadAvaThenVerifyGuest,
} from '../../ducks/UI.duck';
import {
  clearRedirectUrl,
  loginOrSignupClick,
  selectLoginOrSugnupRedirectUrl,
} from '../TopbarContainer/Topbar.duck';
import { ThemedTopBar } from '../../components';

export const ThemedTopbarContainerComponent = props => {
  const {
    notApplySearch,
    authInProgress,
    currentPage,
    currentSearchParams,
    currentUser,
    currentUserHasListings,
    currentUserHasOrders,
    history,
    isAuthenticated,
    authScopes,
    hasGenericError,
    location,
    notificationCount,
    onLogout,
    onManageDisableScrolling,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    onResendVerificationEmail,
    onSendMobileCode,
    sendMobileCodeInProgress,
    onResendMobileCode,
    checkValidCode,
    openMissingInfomationModal,
    onOpenMissingInfomationModal,
    waitingForUploadAva,
    onSetupWaitingForUploadAvaThenVerifyGuest,
    isMobileLayout,
    searchSelectedPrediction,
    loginOrSignupRedirectUrl,
    onLoginOrSignupClick,
    clearRedirectUrl,
    ...rest
  } = props;

  useEffect(() => {
    if (isAuthenticated && !!loginOrSignupRedirectUrl) {
      history.push(loginOrSignupRedirectUrl);
      clearRedirectUrl();
    }
  }, [isAuthenticated, loginOrSignupRedirectUrl]);

  //NOTICE: If you want to pass sthing to MODALMISSINGINFOMATION
  // ||
  // ||
  // \/
  //This object was pass to ModalMissingInfomation
  //Just pass properties in this Obj, it will magically
  //transfers to ModalMissingInfomation component.
  const modalMissingInfomationProps = {
    sendMobileCodeInProgress, //State that show code is sending
    onSendMobileCode, //Send mobile code handler
    onResendMobileCode, //Resend mobile code handler
    sendMobileCodeError: null,
    callMobileCodeInProgress: null, //State that show code is calling
    callMobileCodeError: null, //Call error flag
    onCallMobileCode: null, //Call handler,
    checkValidCode,
    onResendVerificationEmail,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    openMissingInfomationModal,
    onOpenMissingInfomationModal,
  };

  return (
    <ThemedTopBar
      notApplySearch={notApplySearch}
      authInProgress={authInProgress}
      currentPage={currentPage}
      currentSearchParams={currentSearchParams}
      currentUser={currentUser}
      currentUserHasListings={currentUserHasListings}
      currentUserHasOrders={currentUserHasOrders}
      history={history}
      isAuthenticated={isAuthenticated}
      authScopes={authScopes}
      location={location}
      notificationCount={notificationCount}
      onLogout={onLogout}
      onManageDisableScrolling={onManageDisableScrolling}
      showGenericError={hasGenericError}
      modalMissingInfomationProps={modalMissingInfomationProps}
      waitingForUploadAva={waitingForUploadAva}
      isMobileLayout={isMobileLayout}
      searchSelectedPrediction={searchSelectedPrediction}
      onSetupWaitingForUploadAvaThenVerifyGuest={onSetupWaitingForUploadAvaThenVerifyGuest}
      onLoginOrSignupClick={onLoginOrSignupClick}
      {...rest}
    />
  );
};

ThemedTopbarContainerComponent.defaultProps = {
  currentPage: null,
  currentSearchParams: null,
  currentUser: null,
  currentUserHasOrders: null,
  notificationCount: 0,
  sendVerificationEmailError: null,
  authScopes: null,
};

ThemedTopbarContainerComponent.propTypes = {
  authInProgress: bool.isRequired,
  currentPage: string,
  currentSearchParams: object,
  currentUser: propTypes.currentUser,
  currentUserHasListings: bool.isRequired,
  currentUserHasOrders: bool,
  isAuthenticated: bool.isRequired,
  authScopes: array,
  notificationCount: number,
  onLogout: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  sendVerificationEmailInProgress: bool.isRequired,
  sendVerificationEmailError: propTypes.error,
  onResendVerificationEmail: func.isRequired,
  onSendMobileCode: func.isRequired,
  onResendMobileCode: func.isRequired,
  checkValidCode: func.isRequired,
  sendMobileCodeInProgress: bool.isRequired,
  hasGenericError: bool.isRequired,
  onLoginOrSignupClick: func.isRequired,
  loginOrSignupRedirectUrl: string,
  clearRedirectUrl: func.isRequired,

  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({ state: object }).isRequired,
};

const mapStateToProps = state => {
  // Topbar needs isAuthenticated
  const { isAuthenticated, logoutError, authScopes } = state.Auth;
  // Topbar needs user info.
  const {
    currentUser,
    currentUserHasListings,
    currentUserHasOrders,
    currentUserNotificationCount: notificationCount,
    sendVerificationEmailInProgress,
    sendMobileCodeInProgress,
    sendVerificationEmailError,
    openMissingInfomationModal,
  } = state.user;
  const { searchSelectedPrediction } = state.SearchPage;

  const { waitingForUploadAva } = state.UI;

  const hasGenericError = !!(logoutError || hasCurrentUserErrors(state));
  return {
    loginOrSignupRedirectUrl: selectLoginOrSugnupRedirectUrl(state),
    authInProgress: authenticationInProgress(state),
    currentUser,
    currentUserHasListings,
    currentUserHasOrders,
    notificationCount,
    isAuthenticated,
    authScopes,
    sendVerificationEmailInProgress,
    sendMobileCodeInProgress,
    sendVerificationEmailError,
    hasGenericError,
    openMissingInfomationModal,
    waitingForUploadAva,
    searchSelectedPrediction
  };
};

const mapDispatchToProps = dispatch => ({
  onLogout: historyPush => dispatch(logout(historyPush)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  onSendMobileCode: (phoneObj, sendSuccess, sendFail) =>
    dispatch(sendMobileCode(phoneObj, sendSuccess, sendFail)),
  onResendMobileCode: (onSuccess, onFail) => dispatch(resendMobileCode(onSuccess, onFail)),
  checkValidCode: (code, verifySuccess, verifyFail) =>
    dispatch(checkValidCode(code, verifySuccess, verifyFail)),
  onOpenMissingInfomationModal: status => dispatch(openMissingInfomationModal(status)),
  onSetupWaitingForUploadAvaThenVerifyGuest: status =>
    dispatch(setupWaitingForUploadAvaThenVerifyGuest(status)),
  onLoginOrSignupClick: (page) => dispatch(loginOrSignupClick({page})),
  clearRedirectUrl: () => dispatch(clearRedirectUrl()),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ThemedTopbarContainer = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ThemedTopbarContainerComponent);

export default ThemedTopbarContainer;
